import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import useDeviceDetect from '../../../hooks/useDeviceDetect'
import { useLoading } from '../../../hooks/useLoading'
import { useBankAccountEvents } from '../../../hooks/useBankAccountEvents'

import { useModalContext } from '../../../context/modalProvider'
import { usePaymentsContext } from '../../../context/paymentProvider'
import { useTranslation } from '../../../context/translationProvider'

import { getPlayerBankAccounts } from '../../../utils/getPlayerBankAccounts'
import { ModalTypes } from '../../../utils/constants'

import { BankAccountWithdrawForm } from '../../molecules/BankAccountWithdrawForm'
import { Drawer } from '../../atoms/drawer'

import { customHeaderStyles, StyledDrawerWrapper, StyledWrapper } from './style'

const DRAWER_WIDTH = '377px'

export const WithdrawDrawer = ({ isPage }) => {
  const [bankAccounts, setBankAccounts] = useState([])
  const [methods, setMethods] = useState([])
  const { isLoading, startLoading, stopLoading } = useLoading()
  const { translate } = useTranslation()
  const { isMobile } = useDeviceDetect()
  const { type, close: onClose } = useModalContext()
  const { withdrawalPaymentMethods, setCurrentMethod } = usePaymentsContext()

  const isOpen = type === ModalTypes.WITHDRAWDRAWER
  const method = methods?.[0]

  const sortPaymentMethods = (methods) => {
    return methods.sort((a, b) => a.orderNumber - b.orderNumber)
  }

  useEffect(() => {
    if (withdrawalPaymentMethods) {
      setMethods(sortPaymentMethods(withdrawalPaymentMethods))
    } else {
      setCurrentMethod(null)
    }
  }, [withdrawalPaymentMethods])

  const getInitialData = async () => {
    startLoading()
    try {
      const { activeAccounts } = await getPlayerBankAccounts()
      setBankAccounts(activeAccounts)
    } catch (error) {
      console.error('Error fetching bank accounts:', error)
    } finally {
      stopLoading()
    }
  }

  useEffect(() => {
    if (!window) return

    window?.dataLayer?.push({
      event: 'withdrawal_page_viewed',
    })

    getInitialData()
  }, [])

  useBankAccountEvents(
    ['bankAccountCreated', 'transactionCompleted', 'bankAccountDeleted'],
    getInitialData
  )

  const renderContent = () => (
    <StyledWrapper isMobile={isMobile}>
      <BankAccountWithdrawForm
        method={method}
        minimumAmount={method?.minimumAmount}
        maximumAmount={method?.maximumAmount}
        bankAccounts={bankAccounts}
        startLoading={startLoading}
        stopLoading={stopLoading}
        isLoading={isLoading}
      />
    </StyledWrapper>
  )

  if (!method || isLoading) return null

  if (isPage) return renderContent()

  return (
    <StyledDrawerWrapper>
      <Drawer
        customWidth={DRAWER_WIDTH}
        isMobile={isMobile}
        customHeaderStyles={isMobile ? customHeaderStyles : null}
        title={isMobile ? translate('payments.withdraw.title') : null}
        isOpen={isOpen}
        onClose={onClose}
        id="withdraw"
      >
        {renderContent()}
      </Drawer>
    </StyledDrawerWrapper>
  )
}

WithdrawDrawer.propTypes = {
  isPage: PropTypes.bool,
}
